import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const CuzTopicUIAPI = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/read_exist_questionario`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'CuzTopicUIAPI');
    }
};
